import React, { PropTypes, Component } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

// import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerInput.scss';
const { RangePicker } = DatePicker;

export default class DatePickerInput extends Component {
  constructor(props) {
    super(props);
    this.renderExtraFooter = this.renderExtraFooter.bind(this);
  }

  renderExtraFooter() {
    const { onChange } = this.props;
    const todayMoment = moment();
    return (
      <div className="text-center">
        <a onClick={() => onChange([todayMoment, moment().add(1, 'months')])}>1 Months</a> |&nbsp;
        <a onClick={() => onChange([todayMoment, moment().add(3, 'months')])}>3 Months</a> |&nbsp;
        <a onClick={() => onChange([todayMoment, moment().add(6, 'months')])}>6 Months</a> |
      </div>
    );
  }

  render() {
    const { onChange, start, end } = this.props;
    return (
      <div>
        <RangePicker
          ref={(node) => {
            this.element = node;
          }}
          renderExtraFooter={this.renderExtraFooter}
          onChange={onChange}
          value={[start, end]}
          {...this.props}
        />
      </div>
    );
  }
}
